import { toSnakeCase } from '../packages/utils/casing'
import ApiBase from './Api'
import { IssuesGroup } from 'types/IssuesGroupEntity'

const ISSUE_GROUPS_API_PATHS = {
    ISSUE_GROUPS: '/issuesgroups',
}

class IssuesGroupApi extends ApiBase {
    async findByCompanyId(companyId: string): Promise<IssuesGroup[]> {
        if (!companyId) {
            return []
        }
        const fetchedIssueGroups = await this._getRequest(ISSUE_GROUPS_API_PATHS.ISSUE_GROUPS, {
            queryParameters: toSnakeCase({
                companyId,
            }),
        })

        return fetchedIssueGroups
    }
}

export default IssuesGroupApi
